/**
 * @praesto/core/notifications — provider-agnostic dispatcher.
 *
 * Phase 1: typed skeleton. Later: writes tenant-scoped notification jobs
 * consumed by a Cloud Function / Cloud Tasks.
 * Contract: packages/contracts/src/core-api.ts (NotificationService).
 */
import type { NotificationService } from "@praesto/contracts";
import type { RuntimeContext } from "../internal/context";
import { pendingPhase2 } from "../internal/pending";

export {
  subscribeNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  type Unsubscribe as NotificationsUnsubscribe,
} from "./inbox-client";

export function createNotificationService(_ctx: RuntimeContext): NotificationService {
  return {
    send: () => pendingPhase2("notifications", "send"),
  };
}
